module.exports = __webpack_public_path__ + "img/Lieblingsbeschäftigung.293636c2.jpg";